import React from "react";
import styled from "styled-components";
import image from "../Assets/heroimage.png";
import { AiFillWindows, AiFillApple } from "react-icons/ai";
import { GiPenguin } from "react-icons/gi";
import space from "../Assets/space.svg";

const Hero = () => {
  return (
    <Container>
      <Wrapper>
        <Left>
          <h2>
            Build <br /> APIs together
          </h2>
          <span>
            Over 20 million developers use Postman. Get <br /> started by
            signing up or downloading the desktop <br /> app.
          </span>
          <Wrap>
            <input type={"email"} placeholder="address@mail.com" />
            <Button2>Sign Up for Free</Button2>
          </Wrap>
          <p>Download the desktop app</p>
          <Social>
            <Icon>
              <AiFillWindows />
            </Icon>
            <Icon>
              <AiFillApple />
            </Icon>
            <Icon>
              <GiPenguin />
            </Icon>
          </Social>
        </Left>
        <Right>
          <Image src={image} />
        </Right>
        <Spacemedia src={space} />
        <Media src={image} />
      </Wrapper>
    </Container>
  );
};

export default Hero;

const Spacemedia = styled.img`
  display: none;

  @media screen and (max-width: 320px) {
    display: block;
    height: 120px;
    align-self: flex-end;
  }
`;

const Space = styled.img`
  height: 210px;
  background-color: red;
  align-self: flex-end;
  @media screen and (max-width: 320px) {
    display: none;
  }
`;

const Media = styled.img`
  display: none;
  @media screen and (max-width: 320px) {
    display: block;
  }
`;

const Button2 = styled.div`
  padding: 11px 15px;
  border: 1px solid rgb(0, 0, 0, 0.1);
  margin-right: 10px;
  border-radius: 0 4px 4px 0;
  background-color: #ff6c37;
  font-size: 16px;
  text-transform: capitalize;
  font-weight: 500;
  color: white;
  transition: all 360ms;

  @media screen and (max-width: 320px) {
    margin-top: 7px;
    border-radius: 4px;
    padding: 10px 30px;
  }

  cursor: pointer;
  :hover {
    background-color: #fc5a1f;
  }
`;

const Right = styled.div`
  position: absolute;
  top: -12%;
  right: 11%;
  width: 60%;
  height: 100%;

  @media screen and (max-width: 320px) {
    display: none;
  }
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  color: rgb(0, 0, 0, 0.6);
  margin-right: 25px;
`;

const Social = styled.div`
  margin-left: 60px;
  display: flex;
`;

const Wrap = styled.div`
  margin-top: 30px;
  margin-left: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 320px) {
    flex-direction: column;
    display: flex;
    align-items: flex-start;
  }

  input {
    border-radius: 4px 0 0 4px;
    height: 42px;
    width: 300px;
    border: 1px solid #fc5a1f;
    padding-left: 10px;
    ::placeholder {
      font-size: 15px;
    }
    @media screen and (max-width: 768px) {
      flex-direction: column;
      width: 166px;
      height: 36px;
      border-radius: 4px;
      margin-bottom: 13px;
      display: flex;
      ::placeholder {
        font-size: 12px;
      }
    }
  }
`;

const Container = styled.div`
  overflow: hidden;
  position: relative;
  height: 700px;

  @media screen and (max-width: 320px) {
    height: auto;
  }
`;
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 320px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  display: flex;

  @media screen and (max-width: 780px) {
    margin-top: 30px;
    h2 {
      margin-left: 60px;
      font-size: 20px;
    }

    span {
      width: 70%;
      margin-left: 60px;
      font-size: 18px;
      font-weight: 400;
    }

    p {
      margin-left: 60px;
      font-weight: 500;
      font-size: 14px;
      color: rgb(0, 0, 0, 0.5);
    }
  }

  h2 {
    margin-left: 60px;
    font-size: 29px;
  }

  span {
    margin-left: 60px;
    font-size: 18px;
    font-weight: 400;
  }

  p {
    margin-left: 60px;
    font-weight: 500;
    font-size: 14px;
    color: rgb(0, 0, 0, 0.5);
  }

  justify-content: center;
  flex-direction: column;
`;
const Image = styled.img`
  height: 100%;
  object-fit: cover;
`;
